import { Injectable } from '@angular/core';
import { loadStripe, Stripe, StripeElements, StripeCardElement } from '@stripe/stripe-js';
import { HttpService } from '../http/http.service';
import { HttpParams } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CardTokenService {
  stripe!: Stripe | null;
  elements!: StripeElements | null;
  cardElement!: StripeCardElement | null;
  private publicToken : BehaviorSubject<string> = new BehaviorSubject('');


  constructor(
    private httpService: HttpService,
    ) { }

 getPublicToken(id_store:string){
    let params : HttpParams = new HttpParams()
    .append('id_store', String(id_store))
    return this.httpService.get('subscriptions/token', params)
  }


  async initialize(id_store: string) {
    
    const {data} = await this.getPublicToken(id_store)
    
    this.stripe = await loadStripe(data);

  }

  async mountCardElement(containerId: string) {
    if (!this.stripe) return console.error('Stripe no inicializado');
    this.elements = this.stripe.elements();

    this.cardElement = this.elements.create('card', {
        hidePostalCode: true,
        disableLink: true
    });

    this.cardElement.mount(`#${containerId}`);
  }

  async createToken() {
    if (!this.stripe || !this.cardElement) {
      console.error('Stripe o CardElement no inicializado');
      return;
    }

    const { token, error } = await this.stripe.createToken(this.cardElement);
    return { token, error };
    // if (error) {
    //   console.error('Error al tokenizar:', error.message);
    //   return { error };
    // }

    // return { token };
  }
}
